/* ==========================================================================
   DIDIBOU V3 — MOTION
   Système central : reveals échelonnés, parallaxe décoratif léger,
   sections scroll-driven. Vanilla, IntersectionObserver + rAF.
   Respecte prefers-reduced-motion (le token --motion passe à 0).
   ========================================================================== */
(() => {
  document.documentElement.classList.add('js');

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals au scroll ----------
     data-reveal : l'élément apparaît quand il entre dans le viewport.
     data-reveal-group : ses enfants [data-reveal] reçoivent un index de stagger. */
  document.querySelectorAll('[data-reveal-group]').forEach((group) => {
    group.querySelectorAll('[data-reveal]').forEach((el, i) => {
      el.style.setProperty('--reveal-index', i);
    });
  });

  const revealables = document.querySelectorAll('[data-reveal]');
  if (reduced) {
    revealables.forEach((el) => el.classList.add('is-in'));
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    revealables.forEach((el) => io.observe(el));
  }

  /* ---------- Parallaxe décoratif léger ----------
     data-parallax="0.15" : déplacement vertical proportionnel au scroll,
     réservé au décor (jamais au contenu). Transform seul → pas de reflow. */
  const layers = [...document.querySelectorAll('[data-parallax]')];
  if (layers.length && !reduced) {
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      layers.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom < -vh || rect.top > vh * 2) return;
        const speed = parseFloat(el.dataset.parallax) || 0.15;
        const progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        el.style.transform = `translate3d(0, ${(-progress * speed * 100).toFixed(2)}px, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Progression de scroll par section ----------
     data-scroll-progress : la section expose --progress (0 → 1) pendant sa
     traversée. Sert aux chorégraphies (section 8 : la couleur qui monte). */
  const tracked = [...document.querySelectorAll('[data-scroll-progress]')];
  if (tracked.length) {
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      tracked.forEach((el) => {
        const rect = el.getBoundingClientRect();
        /* Section bien plus haute que le viewport : progression pendant le
           pin de lecture. Sinon : progression sur toute la traversée, pour
           que l'effet reste lent et lisible. */
        const total = rect.height - vh;
        const p = total > vh * 0.4
          ? Math.min(1, Math.max(0, -rect.top / total))
          : Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));
        el.style.setProperty('--progress', reduced ? 1 : p.toFixed(4));
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }
})();
